"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemName = exports.ListItem = exports.List = exports.ArrowContainer = exports.ArrowIcon = exports.Input = exports.Header = exports.Wrapper = exports.Required = exports.SelectTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowIcon_1 = require("../../../assets/svg-components/ArrowIcon");
const Typography_1 = __importDefault(require("../../UI/Typography"));
exports.SelectTitle = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
`;
exports.Required = styled_components_1.default.div `
  display: inline;
  color: ${props => props.theme.palette.RED_100};
  margin-left: ${props => props.theme.spacing.s2}px;
`;
exports.Wrapper = styled_components_1.default.div `
  width: ${props => (props.width && typeof props.width === 'string' ? props.width : `${props.width}px`)};
  margin-top: ${props => props.theme.spacing.s1}px;
  position: relative;
  font-size: ${props => props.theme.typography.size.s3}px;
  user-select: none;
`;
exports.Header = styled_components_1.default.button `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  outline: none;
  border: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-radius: ${props => props.theme.constants.borderRadius.xss}px;
  background-color: ${props => (props.disabled ? props.theme.palette.LIGHT_GRAY_30 : props.theme.palette.BW_100)};
  height: ${props => props.theme.constants.SelectDropdownHeight.md}px;
  padding: 0;
  cursor: pointer;
`;
exports.Input = styled_components_1.default.input `
  border: none;
  height: 100%;
  width: 100%;
  border-top-left-radius: ${props => props.theme.constants.borderRadius.xss}px;
  border-bottom-left-radius: ${props => props.theme.constants.borderRadius.xss}px;
  margin-right: ${props => props.theme.spacing.s0}px;
  padding-left: ${props => props.theme.spacing.s3}px;
  font-size: ${props => props.theme.typography.size.s3}px;
  color: ${props => props.theme.palette.LIGHT_BLACK};
  :focus {
    outline: ${props => props.theme.attributes.outlineSize.sm}px solid ${props => props.theme.palette.ORANGE_40};
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
  }
`;
exports.ArrowIcon = (0, styled_components_1.default)(ArrowIcon_1.ArrowIcon) `
  flex-shrink: 0;
  height: ${props => props.theme.constants.SelectDropdownIconHeight.md}px;
  margin: 0;
  ${props => (props.isOpen ? 'transform: rotate(180deg);' : null)}
  > path {
    stroke: ${props => props.disabled && props.theme.palette.BLUE_GRAY_40};
  }
`;
exports.ArrowContainer = styled_components_1.default.div `
  background: ${props => props.theme.palette.LIGHT_GRAY_20};
  height: 100%;
  width: ${props => props.theme.constants.blockWidth.s4}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-top-right-radius: ${props => props.theme.constants.borderRadius.xss}px;
  border-bottom-right-radius: ${props => props.theme.constants.borderRadius.xss}px;
`;
exports.List = styled_components_1.default.div `
  ${props => !props.isOpen && 'visibility: hidden;'}
  margin-top: ${props => props.theme.spacing.xs}px;
  padding: 0;
  position: absolute;
  z-index: ${props => props.theme.constants.zindex.dropdown};
  ${props => !props.takeContentWidth && 'width: 100%;'}
  ${props => props.isOpen && 'width: 100%;'}
  max-height: ${props => props.theme.constants.SelectDropdownHeight.xxl}px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: ${props => props.theme.spacing.s1}px;
  }
  ::-webkit-scrollbar-track {
    background: ${props => props.theme.palette.LIGHT_GRAY};
    border-radius: ${props => props.theme.spacing.s1}px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.palette.MEDIUM_GRAY};
    border-radius: ${props => props.theme.spacing.s1}px;
  }
  border: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  background-color: white;
  box-shadow: ${props => props.theme.attributes.boxShadow.medium};
  text-align: left;
  -webkit-overflow-scrolling: touch;
`;
exports.ListItem = styled_components_1.default.button `
  display: flex;
  justify-content: flex-start;
  border: none;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  transition: ${props => props.theme.animations.backgroundOnly};
  background-color: ${props => (props.isSelected ? props.theme.palette.BLUE_100 : props.theme.palette.BW_100)};
  &:focus-visible {
    outline: 2px solid ${props => props.theme.palette.ORANGE_40};
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
  }
  &:hover {
    background-color: ${props => (props.isSelected ? props.theme.palette.BLUE_100 : props.theme.palette.BLUE_GRAY_20)};
  }
`;
exports.ListItemName = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
  white-space: normal;
  text-align: start;
  ${props => props.optionsColor && `color: ${props.optionsColor};`}
  ${props => props.isSelected && `color: ${props.theme.palette.BW_100}`};
`;
exports.default = {
    Wrapper: exports.Wrapper,
    Header: exports.Header,
    Input: exports.Input,
    ArrowIcon: exports.ArrowIcon,
    ArrowContainer: exports.ArrowContainer,
    List: exports.List,
    ListItem: exports.ListItem,
    ListItemName: exports.ListItemName
};
